import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ConversationDetailSectionIds = {
  AGENT_ANALYSIS: 'agent_analysis',
  SPECIFICATIONS: 'specifications',
  SUPPLIER_DETAILS: 'supplier-details',
} as const

export type ConversationDetailSectionIdEnum = Enum<
  typeof ConversationDetailSectionIds
>
